import * as Sentry from "@sentry/react";
import { getAppEnv } from "../config/app";

// init sentry client, see https://docs.sentry.io/platforms/javascript/#integrating-the-sdk
if (process.env.REACT_APP_SENTRY_DSN) {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  const environment = process.env.REACT_APP_SENTRY_ENVIRONMENT
    ? process.env.REACT_APP_SENTRY_ENVIRONMENT
    : getAppEnv();
  const ignoreErrors = ["Object captured as exception"];

  Sentry.init({
    dsn,
    environment,
    ignoreErrors,
  });
}
